import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { AuditBenchSummaryInputDTO } from 'app/model/audit-bench-summary-input-dto';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { ClosingMeetingDTO } from './closingMeetingDTO';
import { ReminderMailDetailsDTO } from 'app/model/monthly-reminder-mail-bean';
import { UrlConfigService } from './url-config.service';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
@Injectable({
  providedIn: 'root',
})
export class AuditorBenchService {
  //url = environment.SERVER_URL;
  url: string;
  token = '';
  TOKEN = 'token';

  constructor(private http: HttpClient, private urlConfigService: UrlConfigService) {
    this.url = this.urlConfigService.apiServerUrl;
  }

  getAuditBenchList(auditBenchSummaryInputDTO: AuditBenchSummaryInputDTO) {
    return this.http.post(`${this.url}auditor-bench/list`, auditBenchSummaryInputDTO);
  }

  performOperation(auditBenchSummaryInputDTO: AuditBenchSummaryInputDTO) {
    return this.http.post(`${this.url}auditor-bench/operations`, auditBenchSummaryInputDTO);
  }

  downloadAuditDetailExcel(auditBenchSummaryInputDTO: AuditBenchSummaryInputDTO) {
    let authKey;
    authKey = localStorage.getItem(this.token);
    const httpOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        Authorization: authKey,
      }),
    };
    return this.http.post(
      `${this.url}auditor-bench/audit-excel`,
      auditBenchSummaryInputDTO,
      httpOptions
    );
  }

  downloadAllFiles(auditBenchSummaryInputDTO: AuditBenchSummaryInputDTO) {
    let authKey;
    authKey = localStorage.getItem(this.token);
    const httpOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        Authorization: authKey,
      }),
    };
    return this.http.post(
      `${this.url}auditor-bench/download-all`,
      auditBenchSummaryInputDTO,
      httpOptions
    );
  }

  getDepartmentClosingReport(closingMeetingDTO: ClosingMeetingDTO) {
    return this.http.post(`${this.url}closingMeeting/departmentClosingReport`, closingMeetingDTO);
  }

  updateAndSendMeeting(closingMeetingDTO: ClosingMeetingDTO) {
    return this.http.post(`${this.url}closingMeeting/updateAndSendMeeting`, closingMeetingDTO);
  }

  skipClosingMeeting(closingMeetingDTO: ClosingMeetingDTO) {
    return this.http.post(`${this.url}closingMeeting/skipClosingMettingStatutory`, closingMeetingDTO);
  }

  getSiteClosingReport(closingMeetingDTO: ClosingMeetingDTO) {
    return this.http.post(`${this.url}closingMeeting/getSiteClosingReport`, closingMeetingDTO);
  }

  getmeetingDataClosingMeeting(closingMeetingDTO: ClosingMeetingDTO) {
    return this.http.post(
      `${this.url}closingMeeting/getmeetingDataClosingMeeting`,
      closingMeetingDTO
    );
  }

  skipDraftReportStage(closingMeetingDTO: ClosingMeetingDTO) {
    return this.http.post(
      `${this.url}closingMeeting/skipDraftReportOnClickClosingSkipStatutory`,
      closingMeetingDTO
    );
  }

  initiateCAConfirmation(auditBenchSummaryInputDTO: AuditBenchSummaryInputDTO) {
    return this.http.post(`${this.url}auditor-bench/initiateCAConfirmation`, auditBenchSummaryInputDTO);
  }

  downloadObservationTemplate(auditBenchSummaryInputDTO: AuditBenchSummaryInputDTO) {

    let authKey;
    authKey = localStorage.getItem(this.token);
    const httpOptions = {
      responseType: 'blob' as 'json',
      headers: new HttpHeaders({
        'Authorization': authKey,
      })
    };
    return this.http.post(
      `${this.url}auditor-bench/download-observation-template`,
      auditBenchSummaryInputDTO,
      httpOptions
    );
  }


  uploadObservationTemplate(formData: FormData): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: localStorage.getItem(this.TOKEN) || '',
    });

    return this.http.post(`${this.url}auditor-bench/upload-observation-template`, formData, {
      headers
    }).pipe(
      catchError((error) => {
        console.error('Upload error:', error);
        return throwError(() => new Error('Upload failed. Please try again.'));
      })
    );
  }

  getValueNcIsFillOrNot(auditBenchSummaryInputDTO: AuditBenchSummaryInputDTO) {
    return this.http.post(`${this.url}auditor-bench/upload-observation-check-nc`, auditBenchSummaryInputDTO);
  }

  private callMethodSource = new Subject<void>();
  callMethod$ = this.callMethodSource.asObservable();

  triggerUploadObservationList() {
    this.callMethodSource.next();
  }
}
